import type { RouterConfig } from '@nuxt/schema'

import routes from '@/app/router/routes'

export default {
  routes: (_routes) =>
    [
      ...routes,
      {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@b2ag/micro-front-not-found/view'),
      },
    ] as typeof _routes,
  scrollBehavior(to, _from, savedPosition) {
    if (to.query.page) {
      return false
    }

    return savedPosition || { left: 0, top: 0 }
  },
} satisfies RouterConfig
